import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-black to-[#001022] text-gray-300 py-6 mt-10">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p>© 2025 Swaranjali Music Classes. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
